import { InfoCircleIcon } from './info-circle-icon'
import { Cross } from './cross'

const svgs = {
  InfoCircleIcon,
  Cross,
}

export { svgs }
